/** Removes insignificant floating-point noise after converting a ratio to percent. */
export function normalizePercentage(value: number): number {
  const percentage = Number(value) * 100;
  return Number.isFinite(percentage)
    ? Number(percentage.toPrecision(12))
    : percentage;
}